import { connect } from "react-redux";
import {
  getData,
  getId,
  getLoaded,
  getSize
} from "../../reducers/crossword/selectors";

import Cells from "./Cells";

const mapStateToProps = state => ({
  loaded: getLoaded(state),
  id: getId(state),
  data: getData(state),
  size: getSize(state)
});

export default connect(mapStateToProps)(Cells);



// WEBPACK FOOTER //
// ./src/components/Cells/CellsContainer.js